module.exports = __webpack_public_path__ + "ci_jandi.f8887.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_jandi.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_jandi.svg
// module chunks = main